import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerScanComponent } from './pages/customer-scan/customer-scan.component';
import { HomeComponent } from './pages/home/home.component';
import { Page404Component } from './components/page404/page404.component';
import canActivateTeam, { AuthGurdService }  from '../api-providers/services/auth-guard.service'
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "registration/:slug",
    component: CustomerScanComponent,
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [canActivateTeam]
  }, 
  {
    path: 'login',
    component: LoginComponent
  }, 
  {
    path: "**",
    component: Page404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGurdService]
})
export class AppRoutingModule { }
